(function () {
    'use strict';

    angular.module("imApp").factory("jobScheduleService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1663,
                    parameters: parms || {}
                });
            },
            listRepeatEveryTypes: function (parms) {
                return $ihttp.post({
                    method: 1664,
                    parameters: parms || {}
                });
            },
            listRepeatEveryNumbers: function (parms) {
                return $ihttp.post({
                    method: 1665,
                    parameters: parms || {}
                });
            },
            addToQueue: function (edit) {
                return $ihttp.post({
                    method: 3400,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1666,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
